import { Box } from "@chakra-ui/react";
import { AppHeader, TableComponent } from "@components/index";
import { StyledDashboardLayoutChildContainer } from "@root/components/common/style";
import { LANGUAGE } from "@root/constants";
import { TABLE_ITEM_LAYOUT_TYPE } from "@root/constants/common";
import { TERMS_CONTENT } from "@root/constants/terms-conditions";
import { getCurrentLanguage } from "@root/store/selectors/features";
import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";

export const TermsConditions: React.FC = () => {
  const currentLanguage = useSelector(getCurrentLanguage);

  return (
    <StyledDashboardLayoutChildContainer flex={1}>
      <AppHeader title={t("common:sideMenu.termsCondition")} minH={"83px"} />
      <Box height={"100%"} overflowY={"scroll"} padding={"16px"}>
        <TableComponent
          tableData={
            currentLanguage === LANGUAGE.ENGLISH
              ? TERMS_CONTENT.CONTENT_EN
              : TERMS_CONTENT.CONTENT_KO
          }
          itemType={TABLE_ITEM_LAYOUT_TYPE.TERMS_CONDITIONS}
          modelOption={{}}
          model={{}}
        />
      </Box>
    </StyledDashboardLayoutChildContainer>
  );
};
